<div class="align-items-center" style="display: inline-flex;">
    <input class="form-check-input" (click)="seleccionarLocker()" type="radio" name="flexRadioDefault" id="flexRadioDefault1">
</div>